import { render, staticRenderFns } from "./OverviewNote.vue?vue&type=template&id=addd1020&scoped=true&"
import script from "./OverviewNote.vue?vue&type=script&lang=js&"
export * from "./OverviewNote.vue?vue&type=script&lang=js&"
import style0 from "./OverviewNote.vue?vue&type=style&index=0&id=addd1020&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "addd1020",
  null
  
)

export default component.exports